import React from "react";
import { Link } from "react-router-dom";
import { Card, CardMedia, CardContent, CardActionArea, Typography, Button, Grid, Box } from '@mui/material';
import "./CardDocumentos.css";

function CardItemDocumentos(props) {
    const { id, page, title, author, imgcard, showLink, to } = props;
    const routeTo = to || `/DocumentoDoVerbete/${id}`;

    return (
        <Grid>
            <Card
                sx={{
                    maxWidth: 345,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: 3,
                    boxShadow: 3,
                    textAlign: 'center',
                    border: '2px solid transparent',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease',
                    '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: 6,
                        border: '2px solid #FFD700',
                    },
                    background: 'linear-gradient(145deg, #1a1a1a, #333)', // Gradiente escuro
                }}
            >
                <CardActionArea
                    component={Link}
                    to={routeTo}
                    sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}
                >
                    <CardMedia
                        component="img"
                        image={imgcard}
                        alt={title}
                        sx={{
                            width: '100%',
                            height: 240,
                            objectFit: 'cover',
                            borderTopLeftRadius: 3,
                            borderTopRightRadius: 3,
                            transition: 'transform 0.3s ease',
                            '&:hover': {
                                transform: 'scale(1.05)',
                            },
                        }}
                    />
                    <CardContent
                        sx={{
                            background: 'linear-gradient(to right, #444, #222)', // Gradiente mais suave
                            padding: '16px',
                            flexGrow: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography
                            variant="h5"
                            component="h2"
                            sx={{
                                fontWeight: 'bold',
                                color: '#FFD700', // Cor dourada
                                minHeight: '56px',
                                overflow: 'hidden',
                                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)', // Sombra no texto
                            }}
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'white',
                                opacity: 0.8,
                                minHeight: '24px',
                                overflow: 'hidden',
                                fontStyle: 'italic', // Texto em itálico
                            }}
                        >
                            {author}
                        </Typography>
                    </CardContent>
                </CardActionArea>

                {showLink && (
                    <Box sx={{ padding: '16px', textAlign: 'center' }}>
                        <Button
                            component={Link}
                            to={routeTo}
                            variant="contained"
                            sx={{
                                fontWeight: 'bold',
                                textTransform: 'none',
                                borderRadius: '25px',
                                backgroundColor: '#FFD700', // Cor dourada
                                color: '#1a1a1a', // Cor do texto escura
                                padding: '12px 24px',
                                fontSize: '18px',
                                transition: 'transform 0.3s ease, background-color 0.3s ease',
                                '&:hover': {
                                    backgroundColor: '#800020', // Cor vinho ao passar o mouse
                                    color: '#fff', // Texto branco no hover
                                    transform: 'scale(1.1)',
                                },
                            }}
                        >
                            Ver Documento
                        </Button>
                    </Box>
                )}
            </Card>
        </Grid>
    );
}

export default CardItemDocumentos;
